import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=21613c9f&scoped=true"
import script from "./risk.vue?vue&type=script&lang=js"
export * from "./risk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21613c9f",
  null
  
)

export default component.exports